<template>
  <v-row>
    <!-- Campo de teléfono -->
    <v-col cols="12" md="4">
      <v-text-field
        label="Número de teléfono"
        v-model="phoneNumber"
        placeholder="Ingresa el número de teléfono"
        clearable
        required
      />
    </v-col>

    <!-- Selector de fecha "Desde" -->
    <v-col cols="12" md="4">
      <v-menu
        v-model="menuFromDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatDateTime(fromDate, fromHour, fromMinute)"
            label="Fecha desde"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-card>
          <v-date-picker
            v-model="fromDate"
            no-title
            scrollable
            :max="maxFromDate"
            color="#006cb7"
            @input="onFromDateChange"
          />
          <v-row class="px-4 pt-2">
            <v-col cols="6">
              <v-select
                v-model="fromHour"
                :items="hours"
                label="Hora"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="fromMinute"
                :items="minutes"
                label="Minuto"
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-end">
            <v-btn text @click="menuFromDate = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>

    <!-- Campo de fecha "Hasta" -->
    <v-col cols="12" md="4">
      <v-menu
        v-model="menuToDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatDateTime(toDate, toHour, toMinute)"
            label="Fecha hasta"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-card>
          <v-date-picker
            v-model="toDate"
            no-title
            scrollable
            :min="fromDate"
            :max="fromDate"
            color="#006cb7"
          />
          <v-row class="px-4 pt-2">
            <v-col cols="6">
              <v-select
                v-model="toHour"
                :items="hours"
                label="Hora"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="toMinute"
                :items="minutes"
                label="Minuto"
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-end">
            <v-btn text @click="menuToDate = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>

    <!-- Botón de aplicar filtros -->
    <v-col cols="12">
      <v-btn color="primary" @click="apply" :disabled="isApplyButtonDisabled">Aplicar</v-btn>
    </v-col>
  </v-row>
</template>
  
<script>
export default {
  data() {
    return {
      phoneNumber: '',
      menuFromDate: false,
      menuToDate: false,
      fromDate: null,
      toDate: null,
      fromHour: '00',
      fromMinute: '00',
      toHour: '23',
      toMinute: '59',
      maxFromDate: this.calculateMaxFromDate(),
      hours: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')),
      minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')),
    };
  },
  computed: {
    isApplyButtonDisabled() {
      return !(this.phoneNumber && this.fromDate);
    },
  },
  methods: {
    calculateMaxFromDate() {
      const currentDate = new Date();
      return currentDate.toISOString().split('T')[0];
    },
    onFromDateChange() {
      const selectedDate = new Date(this.fromDate);

      // Ajustar Fecha Desde
      this.fromHour = '00';
      this.fromMinute = '00';

      // Ajustar Fecha Hasta automáticamente
      const toDateAdjusted = new Date(selectedDate);
      this.toDate = toDateAdjusted.toISOString().split('T')[0];
      this.toHour = '23';
      this.toMinute = '59';
    },
    formatDateTime(date, hour, minute) {
      if (!date) return '';
      const h = hour || '00';
      const m = minute || '00';
      return `${date} ${h}:${m}`;
    },
    apply() {
      const normalizedPhoneNumber = this.phoneNumber.replace(/\+/g, '');
      const fromDateTime = this.formatDateTime(this.fromDate, this.fromHour, this.fromMinute);
      const toDateTime = this.formatDateTime(this.toDate, this.toHour, this.toMinute);

      this.$emit('apply-filters', {
        phoneNumber: normalizedPhoneNumber,
        fromDate: fromDateTime,
        toDate: toDateTime,
      });
    },
  },
};
</script>